import { jsx as e, jsxs as l } from "react/jsx-runtime";
function r(c) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 24 24", width: "1em", ...c, children: /* @__PURE__ */ l("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ e("path", { d: "M4 4h16v16H4z" }),
    /* @__PURE__ */ e(
      "path",
      {
        d: "M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 1c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 3.446A3.558 3.558 0 0115.554 12 3.558 3.558 0 0112 15.554 3.558 3.558 0 018.446 12 3.558 3.558 0 0112 8.446zm-.054 1a2.502 2.502 0 00-2.5 2.5c0 1.378 1.121 2.5 2.5 2.5 1.378 0 2.5-1.122 2.5-2.5 0-1.379-1.122-2.5-2.5-2.5zm.127 1.05c.581 0 .885.39.885.775 0 .142-.04.38-.265.576.232.161.357.39.357.663 0 .513-.424.886-1.008.886-.654 0-.996-.42-.996-.836 0-.279.124-.514.354-.682a.726.726 0 01-.258-.557c0-.478.391-.824.931-.824zm-.071 1.671c-.125.045-.291.142-.291.347a.285.285 0 00.076.217.352.352 0 00.263.099c.206 0 .339-.112.339-.285 0-.154-.067-.278-.387-.377zM12 6.054a5.954 5.954 0 015.947 5.947.32.32 0 01-.64 0A5.313 5.313 0 0012 6.694a.32.32 0 110-.64zm.054 5.005c-.202 0-.274.124-.274.24 0 .098.038.209.309.292.1-.042.227-.127.227-.285 0-.092-.034-.247-.262-.247z",
        fill: "currentColor"
      }
    )
  ] }) });
}
export {
  r as default
};
